import { Box, Paper, Stack, Typography } from "@mui/material";
import type { NsOpenItem } from "@/api/netsuiteMap";
import { CommentButton, MONO, TONES, targetId } from "./shared";

// Places where the flow is still manual, or where something in code needs
// confirming in production.
export function OpenItems({ items, counts, onComment }: {
  items: NsOpenItem[];
  counts: Record<string, number>;
  onComment: (key: string) => void;
}) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0,1fr))" }, gap: 1.5 }}>
      {items.map((o) => {
        const tone = o.kind === "gap" ? TONES.warn : TONES.review;
        return (
          <Paper key={o.id} variant="outlined" sx={{ p: 2, display: "grid", gap: 0.75, alignContent: "start" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box component="span" sx={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: ".06em", textTransform: "uppercase", px: 0.9, py: "2px", borderRadius: "3px", color: tone.fg, bgcolor: tone.bg }}>
                {o.kind === "gap" ? "Still manual" : "To confirm"}
              </Box>
              <CommentButton count={counts[targetId("open_item", o.id)] ?? 0} label={o.title} onClick={() => onComment(o.id)} />
            </Stack>
            <Typography variant="subtitle1" fontWeight={700}>{o.title}</Typography>
            <Typography variant="body2" color="text.secondary">{o.body}</Typography>
          </Paper>
        );
      })}
    </Box>
  );
}
